import { Context } from "@nuxt/types";

import Api from "@/utils/api";

const DEFAULT_POST_LIMITS = 8;

export default class ActivityAuthApi extends Api {
  constructor($axios: Context["$axios"]) {
    super("activityService", $axios);
  }

  async getFollowingPosts(params: PostMeta | null) {
    return await this.request<ManyActivitiesResponse>({
      method: "GET",
      url: "/v3/activities/posts/user/",
      params: {
        limit: params?.limit || DEFAULT_POST_LIMITS,
        next: params?.next || null,
        includes: ["profiles", "ltks", "posts", "media_objects"],
        styled: true,
      },
    });
  }
}
